module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.blogLoaded) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper post"
  }, [(_vm.post.featuredImageUrl) ? _c('div', {
    staticClass: "post__hero",
    style: ('background-image:url(' + _vm.post.featuredImageUrl + ')')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "post__meta"
  }, [_c('span', {
    staticClass: "post__date"
  }, [_vm._v(_vm._s(_vm.post.transformedDate))]), _c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.post.title))])]), _vm._v(" "), _c('div', {
    staticClass: "post__content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.post.flex_content
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "post__footer"
  }, [(_vm.post.isVRBriefing) ? _c('div', {
    staticClass: "post_footer-content",
    domProps: {
      "innerHTML": _vm._s(_vm.blog_article_footer)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post && _vm.post.blog_post_bildquelle) ? _c('div', {
    staticClass: "post_footer-content"
  }, [_c('p', {
    staticClass: "post_footer-bildquelle"
  }, [_vm._v(_vm._s(_vm.post.blog_post_bildquelle))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post__related"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.localizedRelatedPostsText))])]), _vm._v(" "), _c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.featuredPosts,
      "button": "allPosts",
      "compact": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-980662a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BlogPost.vue
// module id = 276
// module chunks = 0